/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ../../node/read-file-sync.node (ignored)
// module id = 1769
// module chunks = 0